import debounce from 'lodash.debounce';

export default class MeilisearchInput {
  rootElement = undefined;

  wrapperElement = undefined;
  inputElement = undefined;
  resetButtonElement = undefined;

  isFilled = false;
  isEmpty = true;

  options = {
    wrapperElement: undefined,
    inputElement: undefined,
    resetButtonElement: undefined,
    inputDebounceTimeMilliseconds: 100,
    // eslint-disable-next-line no-unused-vars
    onInput: (value) => {},
    onInputFilled: () => {},
    onInputEmpty: () => {},
    onInit: () => {},
    onReset: () => {},
  };

  constructor(rootElement, options = {}) {
    this.rootElement = rootElement;

    this.options = {
      ...this.options,
      ...options,
    };

    this.wrapperElement = this.options.wrapperElement || this.rootElement;

    this.inputElement =
      this.options.inputElement ||
      this.rootElement.querySelector('input[type="search"]');
    this.resetButtonElement =
      this.options.resetButtonElement ||
      this.rootElement.querySelector('button[type="reset"]');

    this.init();
  }

  init() {
    this.onInit();
    this.checkInputState();

    this.inputElement.addEventListener(
      'input',
      debounce(() => {
        this.checkInputState();
        this.onInput();
      }, this.options.inputDebounceTimeMilliseconds),
      window.supportPassive
    );

    this.resetButtonElement.addEventListener(
      'click',
      () => {
        this.inputElement.value = '';
        this.inputElement.focus();

        this.disableResetButton();
        this.checkInputState();
        this.onReset();
      },
      window.supportPassive
    );
  }

  checkInputState() {
    const newIsFilled = this.inputElement.value.length;
    const newIsEmpty = !newIsFilled;

    this.rootElement.classList.toggle(
      'meilisearch-input-is-filled',
      newIsFilled
    );

    this.wrapperElement.classList.toggle(
      'meilisearch-input-is-filled',
      newIsFilled
    );

    this.rootElement.classList.toggle('meilisearch-input-is-empty', newIsEmpty);
    this.wrapperElement.classList.toggle(
      'meilisearch-input-is-empty',
      newIsEmpty
    );

    if (newIsFilled !== this.isFilled) {
      if (newIsFilled) {
        this.enableResetButton();
        this.onInputFilled();
      } else {
        this.disableResetButton();
        this.onInputEmpty();
      }
    }

    this.isFilled = newIsFilled;
    this.isEmpty = newIsEmpty;

    return this.isFilled;
  }

  onInit() {
    if (this.options.onInit && typeof this.options.onInit === 'function') {
      this.options.onInit();
    }
  }

  onInput() {
    if (this.options.onInput && typeof this.options.onInput === 'function') {
      this.options.onInput(this.inputElement.value);
    }
  }

  onInputFilled() {
    if (
      this.options.onInputFilled &&
      typeof this.options.onInputFilled === 'function'
    ) {
      this.options.onInputFilled();
    }
  }

  onInputEmpty() {
    if (
      this.options.onInputEmpty &&
      typeof this.options.onInputEmpty === 'function'
    ) {
      this.options.onInputEmpty();
    }
  }

  onReset() {
    if (this.options.onReset && typeof this.options.onReset === 'function') {
      this.options.onReset();
    }
  }

  enableResetButton() {
    this.resetButtonElement.disabled = false;
    this.resetButtonElement.removeAttribute('inert');
  }

  disableResetButton() {
    this.resetButtonElement.disabled = true;
    this.resetButtonElement.setAttribute('inert', 'true');
  }
}
